<template>
    <div class="password">
      <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
<v-card color="white" class="elevation-12">

              <v-toolbar dark color="blue">
                <v-toolbar-title>Update Your Password:</v-toolbar-title>
              </v-toolbar>
          <v-card-text>
                <v-form>
                  <v-text-field
                      v-model="currentUser"
                      label="Email"
                      disabled
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="newpassword"
                      label="Password"
                      :append-icon="show1 ? 'visibility_off' : 'visibility'"
                      :type="show1 ? 'text' : 'password'"
                      hint="Enter your password"
                      counter
                      @click:append="show1 = !show1"
                      required
                    >
                    </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                v-bind:to="{name: 'user', params: {user: currentUser}}"
                block dark
                v-on:click="updatepassword"
                color="blue">Update</v-btn>
              </v-card-actions>
         </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    </div>
</template>

<script>
import db from "./firebaseinit";
import firebase from 'firebase';
export default {
  name: 'register',
  data: function() {
    return {
      show1: false,
      email: '',
      password: '',
      admin: false,
      standard: false
    };
  },
  created () {
    if(firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
      //Gets User Group//
      console.log(this.currentUser)
      console.log(this.users)
      var user = "jared@asctech.net"
      var a = this.users.indexOf(user)
      console.log(a)
      };
      db.collection("companies")
      .orderBy("company")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company
          };
          this.companies.push(data);
        });
      });
  },
  methods: {
    updatepassword: function(e) {
      firebase
      .auth().currentUser
      .updatePassword(this.newpassword)
      .then(function() {
        alert('Password updated');
      },
      err => {
        alert(err.message);
      }
      );

      e.preventDefault();
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Password.vue